import type { Application } from "pixi.js"

/** Best-effort stop — safe when React unmount races Pixi destroy (e.g. / → /dev/room-emulator). */
export function safeStopPixiApplication(
  app: Application | null | undefined
): void {
  if (!app) return
  try {
    if (app.ticker) app.stop()
  } catch {
    // Application already destroyed or ticker torn down.
  }
}

/** Best-effort destroy — idempotent when called after detach(). */
export function safeDestroyPixiApplication(
  app: Application | null | undefined
): void {
  if (!app) return
  try {
    app.canvas?.remove()
    safeStopPixiApplication(app)
    app.destroy(true, { children: true })
  } catch {
    // Ignore — pool / renderer may already be disposed.
  }
}
